import { ApiClient } from "./client"

export interface ReceiptRow {
  SK: string
  PK: string
  type: "receipt"
  status: "uploaded_pending" | "processed" | "failed"
  merchant?: string
  purchase_date?: string
  total_eur?: number
  lines_count?: number
  s3_key: string
  created_at: number
}

export interface UploadUrlResponse {
  receipt_id: string
  key: string
  put_url: string
  expires_in_s: number
}

export interface EntryRow {
  PK: string
  SK: string
  entry_id?: string
  date: string
  description?: string
  amount_eur: number
  istat_category: string
  istat_label: string
  confidence?: number
  edited_by_user: boolean
  receipt_id?: string
  source: "receipt" | "manual" | "assistant"
}

export interface ProcessResponse {
  receipt: ReceiptRow
  entries: EntryRow[]
}

export function listReceipts(api: ApiClient, week?: string) {
  const qs = week ? `?week=${encodeURIComponent(week)}` : ""
  return api.get<{ items: ReceiptRow[]; next_cursor: null }>(`/receipts${qs}`)
}

export function requestUploadUrl(api: ApiClient, filename: string, content_type: string, size: number) {
  return api.post<UploadUrlResponse>("/receipts/upload-url", { filename, content_type, size })
}

export function processReceipt(api: ApiClient, receiptId: string) {
  return api.post<ProcessResponse>(`/receipts/${receiptId}/process`, {})
}

export function deleteReceipt(api: ApiClient, receiptId: string) {
  return api.delete<{ deleted: true; entries_removed: number }>(`/receipts/${receiptId}`)
}

export interface SuggestAssignment { voce_id: string; amount: number; note?: string }
export function suggestMapping(api: ApiClient, body: {
  merchant?: string; total?: number
  lines: { description: string; amount: number }[]
  voci: { id: string; label: string }[]
}) {
  return api.post<{ assignments: SuggestAssignment[] }>(`/diary/suggest`, body)
}

export async function uploadToS3(putUrl: string, file: File, contentType: string): Promise<void> {
  const r = await fetch(putUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  })
  if (!r.ok) throw new Error(`S3 PUT failed ${r.status}`)
}
